import { render } from "./CaseData.vue?vue&type=template&id=6bb53db5&scoped=true&ts=true"
import script from "./CaseData.vue?vue&type=script&lang=ts"
export * from "./CaseData.vue?vue&type=script&lang=ts"

import "./CaseData.vue?vue&type=style&index=0&id=6bb53db5&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb53db5"]])

export default __exports__